import { defineStyleConfig } from '@chakra-ui/react';

const Popover = defineStyleConfig({
  baseStyle: (props) => ({
    content: {
      bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
      borderColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.200',
      boxShadow: 'md',
    },
    header: {
        fontWeight: 'bold',
        borderBottomWidth: '1px',
        borderColor: props.colorMode === 'dark' ? 'gray.700' : 'gray.100',
    },
    arrow: {
        bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
    }
  }),
});

export default Popover;
